import { useState } from 'react';
import Papa from 'papaparse';

export const useCsvParser = () => {
  const [file, setFile] = useState<File>();
  const [columns, setColumns] = useState<string[]>([]);
  const [numRows, setNumRows] = useState(0);
  const [csvData, setCsvData] = useState([]);

  const parseCsv = (file: File) => {
    // Update the fileName state with the name of the uploaded file
    setFile(file);

    // Use FileReader to read the file's contents
    const reader = new FileReader();

    reader.onload = () => {
      // Parse the CSV data
      const parsedData = Papa.parse(reader.result as string);

      // @ts-expect-error: If the parsed data is succedulf
      const columns = Object.values(parsedData.data[0]);
      setColumns(columns as string[]);

      // @ts-expect-error: If the parsed data is succedulf
      setCsvData(parsedData.data.slice(1, 11));

      // Get the number of rows from the parsed data
      // This will give you the number of rows excluding the header row
      // parsedData.data.length would give the number including the header row
      const numRows = parsedData.data ? parsedData.data?.length - 1 : 0;
      setNumRows(numRows);
    };

    reader.readAsText(file);
  };

  return {
    parseCsv,
    file,
    columns,
    numRows,
    csvData
  };
};
